/* eslint-disable no-useless-catch */
/* eslint-disable no-shadow */
import axios from 'axios'
import { extendContactWithCalculatedProperties } from '@/store/helpers'
import { envConfig } from '@/env-config'

const state = () => ({
  token: null,
  tenant_id: null,
  info: null,
  updateInterval: null,
  logout: false,
  fetched: null,
  fetching: false,
})

const getters = {
  token(state) {
    return state.token
  },
  tenant_id(state) {
    return state.tenant_id
  },
  isLogin(state) {
    return !!state.token
  },
  hasUser(state) {
    return !!state.info?.number
  },
  isLogout(state) {
    return state.logout
  },
  isActive(state) {
    return state.info === null || state.info.status === undefined ? true : state.info.status === 'active'
  },
  info(state) {
    if (!state.info) {
      return null
    }
    return state.info
  },
  login(state) {
    return state.info?.number
  },
  balance(state) {
    let sum = '-'
    let type = '-'
    if (state.info && state.info.balance) {
      if (state.info.balance.balance_type === 'inapplicable') {
        sum = 'N/A'
      } else {
        sum = (`${state.info.balance.amount.toFixed(2) || ''} ${state.info.balance.currency || ''}`).trim()
      }
      type = state.info.balance.balance_type
    }
    return {
      sum,
      type,
    }
  },
}

const mutations = {
  updateToken(state, token) {
    state.token = token
  },
  updateTenantId(state, tenant_id) {
    state.tenant_id = tenant_id
  },
  updateInfo(state, info) {
    state.info = info && extendContactWithCalculatedProperties(info)
  },
  setUpdateInterval(state, ref) {
    state.updateInterval = ref
  },
  clearUpdateInterval(state) {
    if (state.updateInterval) {
      clearInterval(state.updateInterval)
      state.updateInterval = null
    }
  },
  setLogoutState(state) {
    state.logout = true
  },
  clearLogoutState(state) {
    state.logout = false
  },
  setFetching(state, bool) {
    state.fetching = bool
  },
  setFetched(state, time) {
    state.fetched = time
  },
}

async function post_request(url, payload) {
  payload.bundle_id = null // getReverseLocalHost()
  return axios.post(url, payload)
}

const actions = {
  async requestOtpSignup(context, payload) {
    console.log('------LOGIN requestOtpSignup------')
    return post_request('/user', payload)
  },
  async requestOtpSignIn(context, payload) {
    console.log('------LOGIN requestOtpSignIn------')
    return post_request('/session/otp-create', payload)
  },
  async requestSignIn(context, payload) {
    console.log('------LOGIN requestSignIn------')
    return post_request('/session', payload)
  },
  async requestOtpVerify(context, payload) {
    console.log('------LOGIN requestOtpVerify------')
    return post_request('/session/otp-verify', payload)
  },
  async storeAccessCredentials(context, data) {
    data.token && context.commit('updateToken', data.token)
    data.tenant_id && context.commit('updateTenantId', data.tenant_id)
  },
  async storeTenantId(context, tenant_id) {
    tenant_id && context.commit('updateTenantId', tenant_id)
  },
  async logout({ commit, dispatch }, { force }) {
    commit('featureFlags/clearFeatureFlags', null, { root: true })
    dispatch('callingNumbers/clearCallingNumbers', null, { root: true })
    dispatch('leadLists/clearSnackbars', null, { root: true })
    commit('clearUpdateInterval')
    commit('setLogoutState')
    try {
      console.log('Force: ', force)
      if (!force) {
        await axios.delete('/session')
      }
    } finally {
      commit('updateToken', null)
      commit('updateTenantId', null)
      dispatch('webrtc/disconnect', { active: false }, { root: true })
      dispatch('agentEvents/disconnect', {}, { root: true })
      commit('callHistory/setItems', null, { root: true })
      commit('contacts/setItems', null, { root: true })
      commit('updateInfo', null)
      commit('setFetching', false)
      commit('setFetched', null)
      commit('clearLogoutState')
    }
  },
  async initGetAccountInfo({ commit, dispatch }) {
    commit('clearUpdateInterval')
    dispatch('getAccountInfo')
    const interval = setInterval(async () => {
      dispatch('getAccountInfo')
    }, envConfig.updateAccountInfoInterval)
    commit('setUpdateInterval', interval)
  },
  async getAccountInfo({ state, commit, dispatch }) {
    try {
      if (state.fetching) return

      const now = new Date().getTime()
      if (state.fetched && now - state.fetched < 1000 * 60 * 5) return

      commit('setFetching', true)
      const r = await axios.get('/user')
      dispatch('callingNumbers/fetchCallingNumbers', r?.numbers?.main, { root: true })
      dispatch('featureFlags/fetchAllFeatureFlagState', r?.email, { root: true })
      commit('updateInfo', r)
      dispatch('agentEvents/setAccountInfo', { agentId: r?.numbers?.main, agentName: r?.name }, { root: true })
      commit('setFetched', new Date().getTime())
      return
    } catch (e) {
      if (e) console.error('On "getAccountInfo" account', e)
    } finally {
      commit('setFetching', false)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
